import { gql } from '@apollo/client';

const subFragments = {
  ContactReasonItem: gql`
    fragment ContactReasonItemProperties on ContactReasonItem {
      id
      enabled
      text
      icon
      color
    }
  `,
};

const fragments = {
  Accounts: gql`
    fragment AccountProperties on Account {
      custom {
        image
        color
        accountName
      }
      accountType
      id
      userId
      userName
      companyId
      masterCompanyId
      accountCode
      accountColor
      companyName
      tradeName
      panelStatus
      partitionNumber
      automation
      armDisarmEnabled
      armDisarmPartitions
      armDisarmAllPartitions
      armDisarmUser
      armDisarmDate
      email
      accessToken
      webService
      isCloud
      gprsIMEI
      hasPermissionToOpenSO
      requesterId
      serviceOrdersEnabled
      hasPermissionToViewSO
      hasPermissionToViewOccurrenceLogs
      hasPermissionToViewOpenSO
      hasPermissionToViewCameras
      hasActiveIntegrationSIM
      hasRecordingEnabled
      hasToShowPostponeArmDisarm
      hasPermissionToPostponeArm
      hasPermissionToMySecurityServices
      hasPermissionToInhibitZones
      hasPermissionToViewMedia
      hasPermissionToScheduledArrival
      hasPanicEnabled
      hasContactEditionPermission
      hasPermissionToCreateUser
      hasSIMCloudRecordingEnabled
      hasPermissionToViewUnitSendedCommands
      notificationMoment
      timezone
      onDemandEnabled
      hasBilletEnabled
      showZones
      showUsers
      showContacts
      urlInsideBillet
      postponeArmEventId
      webServiceUsername
      webServicePassword
      isOnlyPanic
      hasCountryRestriction
      isRTSP
      isSIMCloud
      hasPermissionToPayment
      iuguToken
      iuguAccountId
      iuguCustomerId
      companyPhone1
      companyTradeName
      companyWhatsapp
      accessCommands
      hasPermissionToVacation
      isVacationEnabled
      hasPermissionToFriendshipCircles
      maintenance {
        enabled
        startDate
        endDate
      }
      showTimeTable
    }
  `,
  Timeline: gql`
    fragment TimelineProperties on Timeline {
      id
      type
      description
      date
      personName

      event {
        auxiliary
        code
        occurrenceId
        partitionCode
        partitionDescription
        isOpen
        observation
      }
      command {
        messageReturn
        commandDescription
        door
        partitionNumber
      }
      logs {
        id
        text
        date
      }
      serviceOrder {
        serviceOrderId
        observation
        executant
        solution
        cause
        status
        scheduleDate
        endDate
      }
      images {
        url
        date
      }
    }
  `,
  UserAndContacts: gql`
    ${subFragments.ContactReasonItem}
    fragment UserAndContactsProperties on UserAndContact {
      id
      name
      priority
      functionName
      phone
      additionalPhone
      type
      allPartitions
      codeAllPartitions
      nextel
      answerPassword
      answerCoercion
      email
      questionPassword
      taxpayerIdentification
      identificationNumber
      observation
      ligacaoUra
      idFuncao
      function {
        enabled
        name
        id
      }
      list
      partitions {
        partition
        partitionId
        code
      }
      contactsReason {
        fire {
          ...ContactReasonItemProperties
        }
        violation {
          ...ContactReasonItemProperties
        }
        medical {
          ...ContactReasonItemProperties
        }
        panic {
          ...ContactReasonItemProperties
        }
      }
    }
  `,
  Events: gql`
    fragment EventsProperties on Timeline {
      id
      type
      description
      date

      masterCompanyId
      accountId
      accountCode
      accountName

      event {
        auxiliary
        code
        occurrenceId
        partitionCode
        partitionDescription
        isOpen
      }
      command {
        messageReturn
        commandDescription
        door
        partitionNumber
      }
      logs {
        id
        text
        date
      }
    }
  `,
  ServiceOrders: gql`
    fragment ServiceOrderProperties on ServiceOrder {
      id
      serviceOrderId
      sequential
      type
      date
      endDate
      hasOSImages
      defect
      description
      scheduleDate
      executant
      solution
      cause
      status

      masterCompanyId
      accountId
      accountCode
      accountName
    }
  `,
  TimeTableCalendarDay: gql`
    fragment TimeTableCalendarDayProperties on TimeTableCalendarDay {
      status
      from
      to
    }
  `,
};

export default fragments;
